module.exports = __webpack_public_path__ + "static/media/profileImg3.02ce5ebb.png";